import React from 'react';
import Icon from '../openplay/OpenPlayIcon';
import PlaceListItem from './PlaceListItem';
import EventListItem from './EventListItem';
import PanelEmptyState from './PanelEmptyState';

const MapSidePanel = ({
  mapSideTab,
  onChangeTab,
  placeList,
  listEvents,
  userLocation,
  getEventTypeIconLabel,
  eventTypeStyles,
  fallbackEventImage,
  onLocatePlace,
  onLocateEvent,
  onApplyEvent,
  onShareEvent,
}) => {
  return (
    <div className="hidden lg:block absolute top-[92px] bottom-6 left-6 z-[65] w-[320px]">
      <div className="h-full bg-white rounded-xl border border-border shadow-elevation-3 overflow-hidden flex flex-col">
        <div className="px-4 pt-4">
          <div className="flex items-center gap-2 bg-muted/40 p-1 rounded-full">
            <button
              type="button"
              onClick={() => onChangeTab('events')}
              className={`flex-1 h-9 rounded-full text-xs font-semibold transition-smooth ${
                mapSideTab === 'events' ? 'bg-white text-foreground shadow-elevation-1' : 'text-muted-foreground'
              }`}
            >
              <span className="inline-flex items-center gap-1">
                <Icon name="CalendarIcon" size={14} />
                진행중 이벤트 ({listEvents.length})
              </span>
              {mapSideTab === 'events' && <span className="block mt-1 h-0.5 bg-primary rounded-full" />}
            </button>
            <button
              type="button"
              onClick={() => onChangeTab('places')}
              className={`flex-1 h-9 rounded-full text-xs font-semibold transition-smooth ${
                mapSideTab === 'places' ? 'bg-white text-foreground shadow-elevation-1' : 'text-muted-foreground'
              }`}
            >
              <span className="inline-flex items-center gap-1">
                <Icon name="MapPinIcon" size={14} />
                등록된 장소 ({placeList.length})
              </span>
              {mapSideTab === 'places' && <span className="block mt-1 h-0.5 bg-primary rounded-full" />}
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto mt-3">
          {mapSideTab === 'places' && (
            <>
              {placeList.length === 0 ? (
                <PanelEmptyState message="등록된 장소가 없습니다." />
              ) : (
                <ul className="divide-y divide-border">
                  {placeList.map((place) => (
                    <PlaceListItem key={place.id} place={place} onLocate={() => onLocatePlace(place)} />
                  ))}
                </ul>
              )}
            </>
          )}

          {mapSideTab === 'events' && (
            <>
              {listEvents.length === 0 ? (
                <PanelEmptyState message="표시할 이벤트가 없습니다." />
              ) : (
                <ul className="divide-y divide-border">
                  {listEvents.map((event) => (
                    <EventListItem
                      key={event.id}
                      event={event}
                      fallbackEventImage={fallbackEventImage}
                      userLocation={userLocation}
                      getEventTypeIconLabel={getEventTypeIconLabel}
                      eventTypeStyles={eventTypeStyles}
                      onLocate={() => onLocateEvent(event)}
                      onApply={onApplyEvent}
                      onShare={onShareEvent}
                    />
                  ))}
                </ul>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MapSidePanel;
